<template>
  <v-container class="ma-0 pa-0" fluid>
    <v-card-title
      class="headline font-weight-regular justify-space-between primary--text"
      >Unlock content
      <v-spacer></v-spacer>
      <v-btn
        class="mx-2"
        fab
        dark
        small
        elevation="0"
        color="primary"
        @click="closeDialog()"
      >
        <v-icon dark>icons8-multiply</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider class="secondary"></v-divider>
    <v-row class="mx-2">
      <vue-snotify></vue-snotify>
      <v-col cols="12" xs-5 sm-12>
        <v-img
          v-if="content.photoURL === ''"
          :aspect-ratio="16 / 9"
          height="200"
          src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
        ></v-img>
        <v-img
          v-else
          :aspect-ratio="16 / 9"
          height="200"
          :src="content.photoURL"
        ></v-img>
      </v-col>
      <v-col cols="12" xs-7 sm-12>
        <h2 class=" font-weight-regular justify-space-between primary--text">
          {{ content.name }}
        </h2>
        <p>{{ content.description }}</p>
        <v-chip
          v-for="(it, index) in content.tags"
          :key="index"
          class=" mr-1  mb-2 primary white--text"
          label
        >
          {{ it }}
        </v-chip>
      </v-col>
      <v-col cols="12">
        <p
          class="headline font-weight-regular justify-space-between secondary--text"
        >
          Next steps
        </p>
        <v-divider class="secondary"></v-divider>
        <v-window v-model="step">
          <v-window-item :value="1">
            <v-row class="mx-2">
              <v-col cols="12" xs="12" sm="8">Do you have an Unlock Code for this topic?</v-col>
              <v-col cols="12" xs="12" sm="4" class="text-right"
                ><v-btn class="gray mr-2" @click="step = 2">No</v-btn>
                <v-btn class="primary" @click="step = 3">Yes</v-btn></v-col
              >
            </v-row>
          </v-window-item>
          <v-window-item :value="2">
            <v-row class="mx-2">
              <v-col cols="12" xs="12" sm="8" v-if="content.buyNowURL != ''"
                >You need to purchase an Access Code to unlock the content click
                the Buy Now button to purchase now.</v-col
              >
              <v-col cols="12" xs="12" sm="8" v-if="content.buyNowURL === ''"
                >Sorry this content is not available to buy yet.</v-col
              >
              <v-col cols="12" xs="12" sm="4" class="text-right">
                <v-btn class="gray mr-2" v-on:click="closeDialog()"
                  >Cancel</v-btn
                >
                       <v-btn
                      v-if="content.buyNowURL !== ''"
                      :href="content.buyNowURL"
                      target="_blank"
                      class="primary"
                      >Buy Now</v-btn>
               </v-col
              >
            </v-row>
          </v-window-item>
          <v-window-item :value="3">
            <v-row class="mx-2">
              <v-col cols="12" xs="12" sm="8"
                >Enter your Access Code from the confirmation email, it should
                be in the format xxxx-xxxx</v-col
              >
              <v-col cols="12" xs="12" sm="4" class="text-right">
                <v-row justify="end">
                  <v-text-field
                    solo
                    v-model.trim="accessCode"
                    hide-details="auto"
                    label="ACCESS CODE"
                    class="mr-2"
                  ></v-text-field>
                  <v-btn height="47" class="mt-2 primary" @click="verifyCode()"
                    >Verify Code</v-btn
                  >
                </v-row>
                <p v-if="notValid === true" class="error--text">
                  {{ notValidCodeMessage }}
                </p>
              </v-col>
            </v-row>
          </v-window-item>
          <v-window-item :value="4">
            <v-row class="mx-2">
              <v-col cols="12" xs="12" sm="8"
                >Your Access Code has been verified. <br />
                Please be aware the Topic is only accesible for 21 days once it
                has been Activated, you can choose to Activate a Topic when you
                are ready to use it. <br />
                So we can continue to create great content could you help us by
                filling out the following details.
              </v-col>
              <v-col cols="12" xs="12" sm="4">
                <v-text-field
                  v-model="accessCode"
                  hide-details="auto"
                  solo
                  readonly
                >
                  <v-icon slot="append" color="success">
                    icons8-checked-checkbox-2
                  </v-icon>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-form ref="courses" v-model="valid" lazy-validation>
                  <v-row>
                      <v-col cols="12" xs="12" sm="6">
                      <v-autocomplete
                       v-model="coursesForm.localAuthorityCountyName"
                       :items="locationDropdown"
                       :filter="customFilter"
                       item-text="name"
                        outlined
                        append-icon="icons8-location-2"
                        hide-details="auto"
                        label="Local Authority County"
                        required
                        :rules="requiredRules"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" xs="12" sm="6">
                      <v-text-field
                        v-model="coursesForm.numberOfParticipants"
                        outlined
                        append-icon="icons8-user-group"
                        hide-details="auto"
                        label="Number of Participants"
                        type="number"
                        required
                        :rules="noRules"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="6">
                      <v-select
                        v-model="coursesForm.ageGroupOfParticipants"
                        outlined
                        :items="ageGroups"
                        multiple
                        append-icon="icons8-group-task-2"
                        hide-details="auto"
                        label="Participants Age Group"
                        required
                        :rules="requiredRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" xs="12" sm="6">
                      <v-menu ref="menu"  v-model="menu" :close-on-content-click="false" :return-value.sync="coursesForm.estimatedDeliveryDate" transition="scale-transition"
                        offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field v-model="coursesForm.estimatedDeliveryDate" label="Estimate Course Delivery Date" append-icon="icons8-clock-2" outlined readonly
                            v-on="on" hide-details="auto" required 
                            :rules="requiredRules"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="coursesForm.estimatedDeliveryDate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            text
                            color="primary"
                            @click="
                              $refs.menu.save(coursesForm.estimatedDeliveryDate)
                            "
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  
                  <v-col cols="12" xs="12" sm="6"> 
                <v-expansion-panels >
                  <v-expansion-panel>
                    <v-expansion-panel-header class="text--left">Gender of Pupils</v-expansion-panel-header>
                      <v-expansion-panel-content>
                       <v-text-field v-model="coursesForm.numberOfGirls" outlined append-icon="icons8-user-group" label="Number of Girls" type="number" required :rules="noRules"></v-text-field>
                        <v-text-field v-model="coursesForm.numberOfBoys" outlined  append-icon="icons8-user-group"  label="Number of Boys" type="number" required :rules="noRules"></v-text-field>
                        <v-text-field v-model="coursesForm.numberOfNonBinary" outlined append-icon="icons8-user-group"  label="Number of NonBinary" type="number" required :rules="noRules"></v-text-field>
                        <v-text-field v-model="coursesForm.numberOfTransgender" outlined append-icon="icons8-user-group" label="Number of Transgender" type="number" required :rules="noRules"></v-text-field>
                      </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
              <v-col cols="12" xs="12" sm="6">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>Ethnicity of Pupils</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-text-field v-model="coursesForm.white" outlined append-icon="icons8-user-group" label="White" type="number" required :rules="noRules"></v-text-field>
                        <v-text-field v-model="coursesForm.mixed " outlined append-icon="icons8-user-group"  label="Mixed or Multiple ethnic groups" type="number" required :rules="noRules"></v-text-field>
                        <v-text-field v-model="coursesForm.asianAsiaBritish" outlined append-icon="icons8-user-group"  label="Asian or Asian British" type="number" required :rules="noRules"></v-text-field>
                        <v-text-field v-model="coursesForm.blackBlackBritish" outlined append-icon="icons8-user-group"  label="Black, African, Caribean or Black British" type="number" required :rules="noRules"></v-text-field>
                        <v-text-field v-model="coursesForm.other" outlined append-icon="icons8-user-group" label="Other ethnic group" type="number" required :rules="noRules"></v-text-field>
                      </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
              </v-row>
                </v-form>
              </v-col>
              
              <v-col cols="12" class="text-right">
                <v-btn class="gray mr-2" v-on:click="closeDialog()">
                  Cancel</v-btn
                >
                <v-btn class="primary" @click="unlockTopic()">Unlock</v-btn>
              </v-col>
            </v-row>
          </v-window-item>
        </v-window>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "UnlockContentPopUp",
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    step: 1,
    accessCode: "",
    menu: false,
    menu1: false,
    valid: true,
    ageGroups: [
      "Reception",
      "Year 1",
      "Year 2",
      "Year 3",
      "Year 4",
      "Year 5",
      "Year 6",
      "Year 7",
    ],
    locationDropdown: [
      {name:'Blaenau Gwent County Borough'},
      {name:'Bridgend County Borough'},
      { name: "Caerphilly County Borough"},
      { name: "Cardiff"},
      { name: "Carmarthenshire"},
      { name: "Ceredigion"},
      { name: "Conwy County Borough"},
      { name: "Denbighshire"},
      { name: "Flintshire"},
      { name: "Gwynedd"},
      { name: "Isle of Anglesey"},
      { name: "Merthyr Tydfil"},
      { name: "Monmouthshire"},
      { name: "Neath Port Talbot"},
      { name: "Newport"},
      { name: "Pembrokeshire"},
      { name: "Powys"},
      { name: "Rhondda Cynon Taf"},
      { name: "Swansea"},
      { name: "The Vale of Glamorgan"},
      { name: "Torfaen"},
      { name: "Wrexham"},
      { name: "England"},
      { name: "Scotland"},
      { name: "Northern Ireland"},
    ],
    requiredRules: [(v) => !!v || "This field is required"],
    numberRule: val => {if(val < 0) return 'Please enter a positive number'
                 return true},
    noRules: [ //TODO ADD RULE FOR POSITIVE NUMBERS
            (v) => !!v || "This field is required",
            (v) => v >= 0 || "Please enter a positive number",
        ],
// GPTR-LNRE	

    coursesForm: {
      id: "",
      name: "",
      numberOfParticipants: "",
      ageGroupOfParticipants: [],
      estimatedDeliveryDate: "",
      userID: "",
      topicName: "",
      topicId: "",
      codeRef: "",
      authorised: true,
      createdBy: "",
      modifiedBy: "",
      createdByID: "",
      createdByEmail: "",
      schoolName: "",
      modifiedByID: "",
      createdTimestamp: "",
      modifiedTimestamp: "",
      expiryDate: "",
      localAuthorityCountyName: "",
      numberOfBoys:"",
      numberOfGirls:"",
      numberOfNonBinary:"",
      numberOfTransgender:"",
      white:"",
      mixed:"",
      asianAsiaBritish:"",
      blackBlackBritish:"",
      other:"",
    },
    codesForm: {},
    validCode: [],
    notValidCodeMessage: "The code you entered is not valid",
    notValid: false,
    today: "",
  }),
  watch: {
    closeDialog: function(val) {
      if(val) {
        this.accessCode = '';
        this.validCode = [];
        this.notValid = false;
        this.codesForm = {};
        this.resetCourse();
      }
    }
  },
  methods: {
     customFilter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1;
    },
    verifyCode() {
     // console.log(JSON.stringify(this.content, null, 2));
      //if code valid
      var Data = [];
      var self = this;
      this.validCode = [];
     // console.log(self.content.id);
     //console.log('access code: ' + self.accessCode);
      this.$firebase.db
        .collection("codes")
        .where("code", "==", self.accessCode)
        .where("topicId", "==", self.content.id)
        .where("used", "==", false)
        .get()
        .then(function(querySnapshot) {
          //show error message if no such code was found in the db
          if (querySnapshot.docs.length === 0) {
            self.notValid = true;
          }
          querySnapshot.forEach(function(doc) {
            Data = doc.data();
            Data.id = doc.id;
            self.validCode.push(Data);
            self.step = 4; //move to the next step if code was found
          });
        })
        .catch(function(error) {
         // console.log("Error getting documents: ", error);
        });
    },
    generateID() {
      return "xxxxyxxx-yxxx-xxxxxx".replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    unlockTopic() {
      // GPTR-LNRE	

      if (this.$refs.courses.validate()) {
        var numGender = parseInt(this.coursesForm.numberOfGirls,10) + parseInt(this.coursesForm.numberOfBoys,10) + parseInt(this.coursesForm.numberOfNonBinary,10) + parseInt(this.coursesForm.numberOfTransgender,10);
        var numEthinicity = parseInt(this.coursesForm.white,10) + parseInt(this.coursesForm.mixed,10) + parseInt(this.coursesForm.asianAsiaBritish,10) + parseInt(this.coursesForm.blackBlackBritish,10) + parseInt(this.coursesForm.other,10);

        var participants = parseInt( this.coursesForm.numberOfParticipants,10);
        if(numGender === participants){
          if ( numEthinicity === participants ){
            this.coursesForm.id = this.generateID();
            this.coursesForm.name = '';
            this.coursesForm.userID = this.$store.getters.currUser.id;
            this.coursesForm.topicId = this.content.id;
            this.coursesForm.topicName = this.content.name;
            this.coursesForm.codeRef = this.accessCode;
            this.coursesForm.authorised = true;
            this.coursesForm.schoolName = this.$store.getters.currUser.schoolName;
            this.coursesForm.createdBy = this.$store.getters.currUser.fullName;
            this.coursesForm.createdByID = this.$store.getters.currUser.id;
            this.coursesForm.createdByEmail = this.$store.getters.currUser.email;
            this.coursesForm.createdTimestamp = this.$moment().toISOString();
            this.coursesForm.estimatedDeliveryDate = this.$moment(this.coursesForm.estimatedDeliveryDate).toISOString();
            this.coursesForm.expiryDate = "";
            //console.log('courses form: ' + JSON.stringify(this.coursesForm, null, 2));
            var self = this;
            self.$firebase.db
              .collection("courses")
              .doc(self.coursesForm.id)
              .set(self.coursesForm)
              .then((docRef) => {
                self.$snotify.info("The topic was unlocked.");
              })
              .catch((error) => {
            //    console.log("Error adding document: ", error);
                self.$snotify.error(error);
              });
            // add user id to code document
          
            this.codesForm = this.validCode[0];
            this.codesForm.coursesId = this.coursesForm.id;
            this.codesForm.userId = this.$store.getters.currUser.id;
            this.codesForm.modifiedBy = this.$store.getters.currUser.fullName;
            this.codesForm.modifiedByID = this.$store.getters.currUser.id;
            this.codesForm.modifiedTimestamp = this.$moment().toISOString();
            this.codesForm.used = true;
            // console.log('codes form: ' + JSON.stringify(this.codesForm, null, 2));
            self.$firebase.db.collection("codes").doc(self.validCode[0].id).update(self.codesForm).then((docRef) => {
                ////self.$snotify.info("The code was modified.");
              })
              .catch((error) => {
              //console.log("Error adding document: ", error);
                self.$snotify.error(error);
              });
            self.closeDialog();
          } else{
              this.$snotify.error("Ensure that the sum of pupils in the Ethnicity category is correct");
          }
        } else{
            this.$snotify.error("Ensure that the sum of pupils in the Gender category is correct");
        }      
      } else {
        this.$snotify.error("Fill out all the fields in order to proceed.");
      }
    },
  resetCourse(){
      this.coursesForm.id = "";
      this.coursesForm.name = "";
      this.coursesForm.numberOfParticipants = "";
      this.coursesForm.ageGroupOfParticipants = [];
      this.coursesForm.estimatedDeliveryDate = "";
      this.coursesForm.userID = "";
      this.coursesForm.topicName = "";
      this.coursesForm.topicId = "";
      this.coursesForm.codeRef = "";
      this.coursesForm.authorised = "";
      this.coursesForm.createdBy = "";
      this.coursesForm.modifiedBy = "";
      this.coursesForm.createdByID = "";
      this.coursesForm.modifiedByID = "";
      this.coursesForm.createdByEmail = "";
      this.coursesForm.createdTimestamp = "";
      this.coursesForm.modifiedTimestamp = "";
      this.coursesForm.expiryDate = "";
    },
    closeDialog() {
      this.step = 1;
      this.accessCode = "";
      this.validCode = [];
      this.notValid = false;
      this.coursesForm = {};
      this.$emit("close-dialog");
    },
  },
};
</script>
